/**
 * Was nach dem Zurückholen wirklich dasteht (7.92).
 *
 * „Zurückholen“ stellt für jedes ausgelagerte Medium einen Auftrag und nimmt
 * dem Projekt sofort den Vermerk *ausgelagert*. Ob die Aufträge durchkommen,
 * sah danach niemand mehr nach: im Bau #300 scheiterte einer dreimal, und die
 * App sagte trotzdem „ist wieder da“ -- mit einem Video ohne Ausgangsdatei
 * darin. Gemerkt hat es erst das Standbild, das aus genau dieser Datei kommt.
 *
 * Also sagt die App es jetzt. Die Regel steht hier und nicht im Blatt, damit
 * dieselbe Rechnung auch der Prüfstand fahren kann.
 */
const UNTERWEGS = new Set(['pending', 'ingesting']);
const OHNE_GRUND = 'die Datei liegt nicht mehr vor';
export function holBefund(medien) {
    const laeuft = medien.some((m) => UNTERWEGS.has(m.status));
    const ohneDatei = medien
        .filter((m) => !UNTERWEGS.has(m.status) && !m.hatOriginal)
        // Der Grund steht am Medium, wenn das Aufbereiten ihn hinterlassen hat --
        // „Box is not configured“ sagt mehr als „fehlt“. Lang ist er manchmal
        // trotzdem; abgeschnitten wird auf einen Satz, der auf ein Telefon passt.
        .map((m) => ({ name: m.name, grund: (m.fehler ?? '').trim().split('\n')[0]?.slice(0, 120) || OHNE_GRUND }));
    const satz = ohneDatei.length === 0
        ? ''
        : `${ohneDatei.length} ${ohneDatei.length === 1 ? 'Medium' : 'Medien'} ohne Ausgangsdatei: ${ohneDatei
            .map((m) => `${m.name} (${m.grund})`)
            .join(', ')}`;
    return { laeuft, ohneDatei, satz };
}
//# sourceMappingURL=zurueckholen.js.map